import { connect } from 'react-redux'

import { selectIsEditingTicketTitle } from 'selectors/app'

import {
  doTicketTitleDraftChanged,
  doStartEditingTicketTitle,
  doStopEditingTicketTitle,
} from 'actions/app'
import { doUpdateTitle } from 'actions/tickets/fields'

import EditableSubject from './view'

const select = state => ({
  isEditingSubject: selectIsEditingTicketTitle(state),
})

const perform = dispatch => ({
  doStartEditingTicketTitle: (...args) =>
    dispatch(doStartEditingTicketTitle(...args)),
  doStopEditingTicketTitle: (...args) =>
    dispatch(doStopEditingTicketTitle(...args)),
  doUpdateTitle: (...args) => dispatch(doUpdateTitle(...args)),
  doTicketTitleDraftChanged: (...args) =>
    dispatch(doTicketTitleDraftChanged(...args)),
})

export default connect(select, perform)(EditableSubject)
